import React, { useState } from "react";
import { Box, TextField, Button, Typography, useTheme } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../api/user";

const ResetPasswordView = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [params, _] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirmedPassword, setConfirmedPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const email = params.get('email')
  const token = params.get('token')

  // value doesn't matter, this webapp doesn't add to DEVS table.
  // because webapp doesn't need to re-auth (as it doesn't need to hash locally)
  // and won't check for the re-auth value
  const device_id = null

  const submit = async () => {
    try {
      await resetPassword(
        email,
        password,
        token,
        device_id,
      )
    } catch (error) {
      setError("Sorry, something went wrong, please try resetting again later. The token might have expired, please request a password reset again");
      console.warn(error)
      return
    }
    setSuccess("Password changed successfully. Redirecting to login...");
    setTimeout(() => {
      navigate('/login')
    }, 3000)
  };

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    px: 16,
    gap: 5,
  };

  const boxStyle = {
    width: 400,
    display: "flex",
    flexDirection: "column",
    p: 2,
    alignItems: "center",
    gap: 2,
  };

  return (
    <Box sx={containerStyle}>
      <Box sx={boxStyle}>
        <img width={100} alt="logotext" src="assets/logos/SmartLog.png" />
        <img width={200} alt="logotext" src="assets/logos/smartLogo_text.png" />
      </Box>

      <p>
        Resetting password for {email}
      </p>

      <Box sx={boxStyle}>
        <TextField
          label="New Password / 新帳戶密碼"
          value={password}
          onChange={(event) => {
            setPassword(event.target.value)
            if (confirmedPassword !== "" && event.target.value !== confirmedPassword) {
              setError("Passwords do not match")
            } else {
              setError("")
            }
          }}
          sx={{ m: 1, width: "100%" }}
          type="password"
        />

        <TextField
          label="Confirm password / 確認帳戶密碼"
          value={confirmedPassword}
          onChange={(event) => {
            setConfirmedPassword(event.target.value)
            if (password === "") {
              return
            }
            if (event.target.value !== password) {
              setError("Passwords do not match")
            } else {
              setError("")
            }
          }}
          sx={{ m: 1, width: "100%" }}
          type="password"
        />

        {error && (
          <Typography variant="subtitle1" sx={{ color: "#FF0000" }}>
            {error}
          </Typography>
        )}
      </Box>

      <Box sx={boxStyle}>
        <Button
          variant="contained"
          onClick={submit}
          sx={{ m: 1, width: "100%" }}
          disabled={password === "" || confirmedPassword !== password}
        >
          Change password
        </Button>
      </Box>

      {success !== "" && (
        <Typography variant="subtitle1">
          {success}
        </Typography>
      )}
    </Box>
  );
};

export default ResetPasswordView;
